import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';

import './index.less';

import { getDefaultIfUndefined } from '../../../utils/typeUtil';
import IbIcon from '../IbIcon';

const MAIN_CLASS_NAME = 'date-picker';
const DROPDOWN_CLASS_NAME = 'date-picker-dropdown';

export interface IDatePickerProps {
  className?: string;
  dropdownClassName?: string;
  value?: string;
  format?: string;
  disabled?: boolean;
  onChange?: (dateString: string) => void;
}

const DatePicker: React.FC<IDatePickerProps> = ({
  className,
  dropdownClassName,
  value,
  format,
  disabled,
  onChange,
}) => {
  value = getDefaultIfUndefined(value, undefined);
  format = getDefaultIfUndefined(format, undefined);
  disabled = getDefaultIfUndefined(disabled, undefined);

  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);

  const dropdownClasses = [DROPDOWN_CLASS_NAME];
  dropdownClassName && dropdownClasses.push(dropdownClassName);

  const onInnerChange = (_: unknown, dateString: string) => onChange?.(dateString);

  return (
    <AntDatePicker
      className={classes.join(' ')}
      clearIcon={<IbIcon iconName="close-one" size={20} />}
      disabled={disabled}
      dropdownClassName={dropdownClasses.join(' ')}
      format={format}
      placeholder=""
      showNow={false}
      suffixIcon={<IbIcon iconName="calendar-three" size={20} />}
      value={value ? moment(value, format) : undefined}
      onChange={onInnerChange}
    />
  );
};

export default DatePicker;
